import { useAppState } from '../../../AppStateProvider';
import type { Contact } from '../../../domain/contact';
import { createContact, mergeContact } from '../../../domain/contact';

import { useCrmContactQuery } from './useCrmContactQuery';

export const useCrmContact = () => {
  const { collectedContactInfo } = useAppState();
  const contactQuery = useCrmContactQuery();

  let contact = mergeContact(contactQuery?.data, collectedContactInfo);

  if ((contactQuery.isError || !contact) && collectedContactInfo?.name) {
    contact = createContact(collectedContactInfo) as Contact;
  }

  return { isLoading: contactQuery.isLoading, contact };
};
